<div>
  <strong> What types of photos should I upload? </strong>
</div>

<ul class="list">
  <li class="list-item">Zoomed-out photo of where the CurbNTurfers will be staying</li>
  <li class="list-item">Wide, horizontally-oriented</li>
  <li class="list-item">Clutter-free</li>
  <li class="list-item">Hour after sunrise or hour before sunset is recommended.</li>
</ul>

<div
  class="alert-danger"
  role="alert"
  *ngIf="form?.get('type')?.value !== 'boondock' && (!photos || !photos.controls || photos.controls.length < 3)"
>
  <div class="_18-px-spacer"></div>
  <p>We recommend at least three photos.</p>
  <div class="_18-px-spacer"></div>
</div>

<div *ngIf="form">
  <div
    dragula="site-images"
    [dragulaModel]="photos?.value"
    (dragulaModelChange)="updatePhotoOrder($event)"
    class="dragula-container"
  >
    <ng-container *ngIf="!offlineMode">
      <ng-container *ngFor="let photo of photos?.controls; let i = index; trackBy: photoOrder">
        <div class="image-card">
          <div class="image-wrapper">
            <div *ngIf="i === 0" class="default-card">Default</div>
            <img [src]="getPhotoUrl(photo)" alt="Boondock Photo" />
            <a role="button" tabindex="0" class="carousel-control carousel-control-prev" (click)="movePhotoUp(i)">
              <span aria-hidden="true" class="icon-prev carousel-control-prev-icon"> </span>
              <span class="sr-only">Previous</span>
            </a>
            <a role="button" tabindex="0" class="carousel-control carousel-control-next" (click)="movePhotoDown(i)">
              <span aria-hidden="true" class="icon-next carousel-control-next-icon"> </span>
              <span class="sr-only">Next</span>
            </a>
          </div>
          <div>
            <div class="_1up-outer-wrapper caption">
              <div class="image-card-caption-wrapper">
                <div class="icon-edit-wrapper caption">
                  <div class="html-embed w-embed">
                    <ion-button (click)="recropPhoto(photo)">
                      <ion-icon name="create"></ion-icon>
                    </ion-button>
                  </div>
                </div>

                <input
                  type="text"
                  class="text-input caption w-input"
                  id="caption-{{ i }}"
                  name="caption-{{ i }}"
                  placeholder="Enter photo caption..."
                  [formControl]="getCaptionControl(photo)"
                />

                <ng-template #photoDeleteTemplate>
                  <div class="icon-trash-wrapper caption">
                    <div class="html-embed w-embed">
                      <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
                    </div>
                  </div>
                </ng-template>

                <curbnturf-delete-confirmation-modal
                  [photo]="photo.value"
                  [name]="'photo with caption \'' + photo?.value?.caption + '\''"
                  [id]="i"
                  [template]="photoDeleteTemplate"
                  [deleteFunction]="removePhotoFunction(i)"
                >
                </curbnturf-delete-confirmation-modal>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="offlineMode">
      <ng-container *ngFor="let photo of photos?.controls; let i = index; trackBy: photoOrder">
        <div class="image-card">
          <div class="image-wrapper">
            <img [src]="getOfflinePhoto(photo.value)" />
            <a role="button" tabindex="0" class="carousel-control carousel-control-prev" (click)="movePhotoUp(i)">
              <span aria-hidden="true" class="icon-prev carousel-control-prev-icon"> </span>
              <span class="sr-only">Previous</span>
            </a>
            <a role="button" tabindex="0" class="carousel-control carousel-control-next" (click)="movePhotoDown(i)">
              <span aria-hidden="true" class="icon-next carousel-control-next-icon"> </span>
              <span class="sr-only">Next</span>
            </a>
          </div>
          <div>
            <div class="_1up-outer-wrapper caption">
              <div class="image-card-caption-wrapper">
                <input
                  type="text"
                  class="text-input caption w-input"
                  id="caption-{{ i }}"
                  name="caption-{{ i }}"
                  placeholder="Enter photo caption..."
                  [formControl]="photo.controls.caption"
                />

                <ng-template #photoDeleteTemplate>
                  <div class="icon-trash-wrapper caption">
                    <div class="html-embed w-embed">
                      <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
                    </div>
                  </div>
                </ng-template>

                <curbnturf-delete-confirmation-modal
                  [photo]="photo.value"
                  [name]="'photo with caption \'' + photo?.value?.caption + '\''"
                  [id]="i"
                  [template]="photoDeleteTemplate"
                  [deleteFunction]="removeOfflinePhotoFunction(photo.value)"
                >
                </curbnturf-delete-confirmation-modal>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<curbnturf-image-upload [options]="uploadOptions" (beforeUpdating)="save()" [updatedFunction]="imagesUpdated()">
</curbnturf-image-upload>
